import React from 'react';
import { RouteButton } from '../../form';
import styles from './NotFoundPage.module.css';

const NotFoundPage: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.status}>404</div>
    <p className={styles.heading}>PAGE NOT FOUND</p>
    <p>
      The page you are looking for might have been removed, had its name changed
      or is temporarily unavailable.
    </p>
    <RouteButton to="/" variant="primary" replace>
      Back to Home Page
    </RouteButton>
  </div>
);

export default NotFoundPage;
